<div class="relative">
	<!-- Added relative positioning container -->
	<input (input)="onInputChange($event)" [placeholder]="placeholder()" [value]="currentTerm()" class="input-field"
								type="text" />
	<span class="absolute inset-y-0 end-0 flex items-center pe-3">
		<icon class="w-4 h-4" icon="fad fa-search fa-primary-blue-500 fa-secondary-blue-700" />
	</span>
</div>
